export default {
  "content": "<g clip-path=\"url(#clip0_2350_44051)\" fill=\"#717684\"><path d=\"M12 0H4a1.333 1.333 0 00-1.333 1.333v13.334A1.333 1.333 0 004 16h8a1.334 1.334 0 001.333-1.333V1.333A1.334 1.334 0 0012 0zm0 14.333a.333.333 0 01-.333.334H4.333A.333.333 0 014 14.333V1.667a.333.333 0 01.333-.334h.727a.273.273 0 01.273.274V2A.667.667 0 006 2.667h4A.667.667 0 0010.667 2v-.393a.273.273 0 01.273-.274h.707a.333.333 0 01.333.334L12 14.333z\"/><path d=\"M10 11.96H6a.707.707 0 100 1.413h4a.707.707 0 000-1.413z\"/></g><defs><clipPath id=\"clip0_2350_44051\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};